// extracted by mini-css-extract-plugin
export default {"jobListDescription":"JobsListDescription_jobListDescription__+pXpb"};